<div class="main-layout">
  <p-menubar [model]="items" class="main-menu">
    <ng-template pTemplate="start">
      <img
        class="app-logo"
        src="assets/img/365-logo.png"
        alt="365"
      />
    </ng-template>
    <ng-template pTemplate="end">
      <div class="menu-actions">
        @if (outboundSyncStatus$ | async; as outboundSyncStatus) {
          <div class="sync-status" aria-label="Outbound sync status">
            @for (entityType of outboundSyncStatus.entityTypes; track entityType.type) {
              <span
                class="sync-status__entity"
                [pTooltip]="entityTypeLabel(entityType.type) + ': ' + entityType.queued + ' queued, ' + entityType.processing + ' processing'"
                tooltipPosition="bottom"
                tooltipStyleClass="sync-status-tooltip"
              >
                <span class="sync-status__entity-label">{{ entityTypeLabel(entityType.type) }}</span>
                <span class="sync-status__count sync-status__count--queued"><i class="pi pi-clock"></i>{{ entityType.queued }}</span>
                <span class="sync-status__count sync-status__count--processing"><i class="pi pi-spin pi-spinner"></i>{{ entityType.processing }}</span>
              </span>
            }
            <span class="sync-status__live" [class.sync-status__live--unavailable]="outboundSyncStatus.live !== 'connected'" [pTooltip]="outboundSyncStatus.live === 'connected' ? 'Live Sync Updates Connected' : outboundSyncStatus.live === 'connecting' ? 'Connecting Live Sync Updates' : 'Live Sync Updates Unavailable'">
              <i [class]="outboundSyncStatus.live === 'connected' ? 'pi pi-circle-fill' : 'pi pi-circle'"></i>
            </span>
          </div>
        }
        <theme-switcher></theme-switcher>
      </div>
    </ng-template>
  </p-menubar>

  <div class="content">
    <app-upload-file-dialog
      (closeDialog)="hideDialog()"
      [visible]="visible"
    ></app-upload-file-dialog>
    <p-toast position="top-right" />
    <p-tabs [value]="currentPage">
      <p-tablist>
        @for (tab of tabs; track tab.route) {
          <p-tab
            [value]="tab.route"
            [routerLink]="tab.route"
            [queryParams]="tab.queryParams"
            [queryParamsHandling]="'merge'"
            [disabled]="!(!tab.hideFor || !tab.hideFor.includes(country))"
            class="flex items-center !gap-2 text-inherit"
            (click)="onTabInteraction(tab.route)"
          >
            <i [class]="tab.icon"></i>
            <span>{{ tab.label }}</span>
            @if (tab.count !== null && tab.count !== undefined) {
              <small class="tab-count">{{ tab.count }}</small>
            }
          </p-tab>
        }
        <span
          src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
          [class]="'flag flag-' + country"
          class="country-flag-slot"
        ></span>
      </p-tablist>
    </p-tabs>
    <router-outlet></router-outlet>
  </div>
</div>
